import { registerSystem } from "yage/components/ComponentRegistry";
import { System } from "yage/components/System";
import { Component, Schema, defaultValue, type } from "yage/decorators/type";
import { GameModel } from "yage/game/GameModel";
import { ChildSchema } from "yage/schemas/entity/Child";
import { ChanceHealOnPickupSchema } from "../effects/ChanceHealOnPickup";
import { EnemyTypeSchema, PlayerTypeSchema } from "yage/components/entity/Types";

@Component("ChanceHealOnPickupEnhancer")
export class ChanceHealOnPickupEnhancerSchema extends Schema {
  @type("number")
  @defaultValue(0.08)
  chance: number;
}

class ChanceHealOnPickupSystem implements System {
  schema = ChanceHealOnPickupEnhancerSchema;
  type = "ChanceHealOnPickupEnhancer";
  dependencies = ["Child"];
  init(entity: number, gameModel: GameModel) {
    if (
      !gameModel.hasComponent(entity, PlayerTypeSchema) &&
      !gameModel.hasComponent(entity, EnemyTypeSchema) &&
      gameModel.hasComponent(entity, ChildSchema)
    ) {
      const parent = gameModel.getTypedUnsafe(entity, ChildSchema).parent!;
      if (!gameModel.hasComponent(parent, "ChanceHealOnPickup")) {
        gameModel.addComponent(parent, ChanceHealOnPickupSchema);
      }
      gameModel.getTypedUnsafe(parent, ChanceHealOnPickupSchema).chance += gameModel.getTypedUnsafe(
        entity,
        ChanceHealOnPickupEnhancerSchema
      ).chance;
    }
  }

  cleanup(entity: number, gameModel: GameModel, ejecting: boolean) {
    if (
      !gameModel.hasComponent(entity, PlayerTypeSchema) &&
      !gameModel.hasComponent(entity, EnemyTypeSchema) &&
      gameModel.hasComponent(entity, ChildSchema)
    ) {
      const parent = gameModel.getTypedUnsafe(entity, ChildSchema).parent!;
      if (gameModel.hasComponent(parent, "ChanceHealOnPickup")) {
        gameModel.getTypedUnsafe(parent, ChanceHealOnPickupSchema).chance -= gameModel.getTypedUnsafe(
          entity,
          ChanceHealOnPickupEnhancerSchema
        ).chance;
      }
    }
  }
}
registerSystem(ChanceHealOnPickupSystem);
